import React from 'react';
import { Alinta, StyleBaseline } from '@alinta-digital/asg';
import GlobalStyle from './GlobalStyle';
import ErrorPage from './view/ErrorPage';
import { ApolloProvider } from '@apollo/client';
import * as cacheStatePkg from '@alinta-digital/myaccount-frontend-api-cachestate';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const authPkg = require('@alinta-digital/myaccount-frontend-api-authentication');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const appStatePkg = require('@alinta-digital/myaccount-frontend-api-appstate');

const appState = appStatePkg.getAppState();

const isGhosting: boolean = authPkg.getAuthenticator().getGhostingStatus();
const cachedGhostingId: string = appState.getUserDataField('ghostingcid');

// if(isGhosting && cachedGhostingId) { //check why isGhosting is not SET

const Root: React.FC<any> = () => {
  if (cachedGhostingId) {
    console.warn('Impersonation in action');
    appState.navigateToLogin();
    // appState.navigateTo('Overiew');
    return <></>;
  }
  const cacheState = cacheStatePkg.getCacheState();
  const apolloClient = cacheState.getApolloClient(cacheState.MYACCOUNT_BFF);
  return (
    <ApolloProvider client={apolloClient}>
      <Alinta>
        <StyleBaseline />
        <GlobalStyle />
        <ErrorPage></ErrorPage>
      </Alinta>
    </ApolloProvider>
  );
};
export default Root;
